
        import * as module0 from '$components/art-viewer.js';import * as module1 from '$components/nsfw-elements.js';import * as module2 from '$components/random-text-getter.js';import * as module3 from '$components/ritual-v3.js';import * as module4 from '$components/search.js';import * as module5 from '$components/tierlist.js'
        const modules = {
            "art-viewer.js": module0,
            "nsfw-elements.js": module1,
            "random-text-getter.js": module2,
            "ritual-v3.js": module3,
            "search.js": module4,
            "tierlist.js": module5,
        };
        export default modules;
      